import { prop, indexBy } from "ramda";
import dataSourceNode from "./dataSourceNode";
import { getDocumentElement } from "../../xmlUtility";

// NodeId is { ds?: String, id: String }

function dataSourceCollection(sources, xpathEngine) {
    let _listener;

    // { String: DataSource }
    const sourceMap = indexBy(prop('name'), sources);

    function checkExists(source, name) {
        if (!source) {
            throw new Error("Unknown data source: " + name);
        }
    }

    function getDataSource(name) {
        return sourceMap[name];
    }

    const hasDataSource = (name) => 
        name in sourceMap;

    function makeDsNode(node, source) {
        return node
            ? dataSourceNode(node, source, xpathEngine, _listener)
            : null;
    }

    const getDataSourceWithCheck = (name) => {
        const ds = getDataSource(name);

        checkExists(ds, name);

        return ds;
    };

    // NodeId -> DataSourceNode
    function getNodeById({ ds, id }) {
        const dsName = ds || '';
        const source = getDataSourceWithCheck(dsName);
        const node = source.getNodeById(id);

        return node
            ? makeDsNode(node, source)
            : null;
    }

    function setListener(listener) {
        _listener = listener;
    }

    /**
     * Returns a dataSourceNode for the specified data source name
     * @param {String} name The name of the data source. If unspecified or blank, returns the main data source.
     * @returns {DataSourceNode} a dataSourceNode positioned at the root of the data source
     */
    const getDom = (name) => {
        const ds = getDataSourceWithCheck(name || '');

        return makeDsNode(ds.getDom(), ds);
    };

    function getMainDocumentElement() {
        const mds = getDataSource('');
        const node = getDocumentElement(mds.getDom());

        return makeDsNode(node, mds);
    }

    function selectNodes(path) {
        return getDom().selectNodes(path);
    }

    const getAll = () => [...sources];

    // interface
    return {
        getAll,
        getDataSource,
        getDataSourceWithCheck,
        hasDataSource,
        getDom,
        getNodeById,
        setListener,
        selectNodes,
        getMainDocumentElement,
    };
}

export default dataSourceCollection;